import React, { useContext, useEffect } from 'react';
import { isMacOs } from 'react-device-detect';
import EditorToolButton from './EditorToolButton';
import TextIcon from '../assets/icons/Text';
import PencilIcon from '../assets/icons/Pencil';
import UndoIcon from '../assets/icons/Undo';
import RedoIcon from '../assets/icons/Redo';
import TrashIcon from '../assets/icons/Trash';
import InfoIcon from '../assets/icons/Info';
import { setActiveTool, clearChanges, undoChanges, redoChanges } from '../store';
import EditorContext from '../store/Editor.context';
import { EDITOR_TOOLS } from '../constants';

var EditorTools = function EditorTools(_ref) {
  var _state$changes$presen;

  var isTour = _ref.isTour,
      toggleIsTour = _ref.toggleIsTour;

  var _useContext = useContext(EditorContext),
      state = _useContext.state,
      dispatch = _useContext.dispatch;

  var textTool = state.activeTool === EDITOR_TOOLS.text;
  var freeformTool = state.activeTool === EDITOR_TOOLS.freeform;
  var disabledUndo = !state.changes.past.length;
  var disabledRedo = !state.changes.future.length;
  useEffect(function () {
    var handleKeyDown = function handleKeyDown(e) {
      var isUndo = e.keyCode === 90 && (isMacOs ? e.metaKey : e.ctrlKey);
      var isRedo = (isMacOs ? e.keyCode === 90 : e.keyCode === 89) && (isMacOs ? e.metaKey && e.shiftKey : e.ctrlKey);

      if (isUndo && !disabledUndo) {
        e.preventDefault();
        dispatch(undoChanges);
      } else if (isRedo && !disabledRedo) {
        e.preventDefault();
        dispatch(redoChanges);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return function () {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [disabledUndo, disabledRedo]);
  return /*#__PURE__*/React.createElement("div", {
    id: "tools",
    className: "flex flex-col w-10 bg-white border-l-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-grow"
  }, /*#__PURE__*/React.createElement(EditorToolButton, {
    id: "tool-text-btn",
    title: "Text",
    active: textTool,
    onClick: function onClick() {
      return dispatch(setActiveTool(!textTool && EDITOR_TOOLS.text));
    }
  }, /*#__PURE__*/React.createElement(TextIcon, {
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement(EditorToolButton, {
    id: "tool-freeform-btn",
    title: "Freeform",
    active: freeformTool,
    onClick: function onClick() {
      return dispatch(setActiveTool(!freeformTool && EDITOR_TOOLS.freeform));
    }
  }, /*#__PURE__*/React.createElement(PencilIcon, {
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement(EditorToolButton, {
    title: isMacOs ? 'Undo (⌘+z)' : 'Undo (Ctrl+z)',
    onClick: function onClick() {
      return dispatch(undoChanges);
    },
    disabled: disabledUndo
  }, /*#__PURE__*/React.createElement(UndoIcon, {
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement(EditorToolButton, {
    title: isMacOs ? 'Redo (⌘+⇧+z)' : 'Redo (Ctrl+y)',
    onClick: function onClick() {
      return dispatch(redoChanges);
    },
    disabled: disabledRedo
  }, /*#__PURE__*/React.createElement(RedoIcon, {
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement(EditorToolButton, {
    title: "Clear all",
    onClick: function onClick() {
      return dispatch(clearChanges);
    },
    disabled: !((_state$changes$presen = state.changes.present) === null || _state$changes$presen === void 0 ? void 0 : _state$changes$presen.length)
  }, /*#__PURE__*/React.createElement(TrashIcon, {
    width: 20,
    height: 20
  })), /*#__PURE__*/React.createElement(EditorToolButton, {
    id: "tool-info-btn",
    title: "Tour",
    active: isTour,
    onClick: toggleIsTour
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    width: 20,
    height: 20
  }))));
};

export default EditorTools;